<template>
  <svg viewBox="0 0 1199 1722" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M605 949c111 0 202-75 202-190 0-107-80-194-189-194-53 0-95 19-127 56h-2c0-77 27-155 117-155 44 0 71 20 80 58h103c-16-96-96-140-187-140-67 0-119 21-156 62-45 52-67 128-66 229 2 142 66 274 225 274zm-6-825c292 0 528 236 528 528 0 291-236 528-528 528-291 0-528-237-528-528 0-292 237-528 528-528zm3 528c61 0 102 51 102 109s-44 104-103 104c-61 0-105-44-105-105 0-65 40-108 106-108z" />
  </svg>
</template>
